import { render } from "./InvestorRelations.vue?vue&type=template&id=393c3c14"
import script from "./InvestorRelations.vue?vue&type=script&lang=js"
export * from "./InvestorRelations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__